import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconCheck = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z" }, void 0) }, void 0));
const Memo = memo(SvgIconCheck);
export default Memo;
//# sourceMappingURL=IconCheck.js.map